// extracted by mini-css-extract-plugin
export default {"container":"LearningCards_container__eYJv2","learningBlock":"LearningCards_learningBlock__Z8M2l","questionBlock":"LearningCards_questionBlock__NCEVe"};